import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../../ReactQuery/useQuery';
import { get } from '../../../../redux/api';
import type { PaymentMethodResponse } from '../../../../../shared/subscriptions/consts';

function fetchPaymentMethod() {
  return get<PaymentMethodResponse>(`/api/organizations/subscription/payment-method`);
}

const getQueryKey = (): QueryKey => ['payment-method'];

/**
 * Fetches the payment setup link
 */
export default function usePaymentMethod() {
  return useQuery<PaymentMethodResponse>({
    queryKey: getQueryKey(),
    queryFn: () => fetchPaymentMethod(),
  });
}
